export const DEFAULT_QR_LINK = 'No link has been provided for the QRCode on this page'

export const defaultSelect = { value: 'all', label: 'all' }

export const defaultLimit = 50
export const defaultPage = 0
export const defaultSort = 'created_at-desc'

export const shortSearchDelay = 300
export const defaultSearchDelay = 500
export const longerSearchDelay = 800

export const defaulConsumerChallengetLimit = 10
export const defaultConsumerChallengeSort = 'end_date-desc'
export const defaultConsumerScanSort = 'consumerScan.created_at-desc'

export enum EConfirmModalTitles {
  CREATE = 'Confirm Create',
  UPDATE = 'Confirm Update',
  EXECUTE_CRON_JOB = 'Confirm Execution',
}
